import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { Formik, Field, Form } from 'formik';
import { get, pick, isEmpty } from 'lodash-es';

import { Box, Button, Text } from '@components/common';
import GooglePropertyField from '@containers/properties/GooglePropertyField';

import { InputField, SelectField } from '@components/form';
import validationSchema from './schema';
import { arry2KeyValue } from '@utils/object';
import { getErrors } from '@utils/error';
import { DEFAULT_BEDROOM_COUNTS } from '@services/minte';
import API from '@utils/api';
import { MoveoutSelectors } from '@redux/MoveoutRedux';
import AuthActions from '@redux/AuthRedux';
import AppActions from '@redux/AppRedux';
//TODO: need to reuse property form

class MoveoutPropertyForm extends React.Component {
  static propTypes = {
    onSubmit: PropTypes.func,
    onCancel: PropTypes.func,
    updateUser: PropTypes.func,
    dateRangeInfo: PropTypes.object
  };

  handleSubmit = async (values, actions) => {
    const { onSubmit, dateRangeInfo, updateUser } = this.props;
    const { setSubmitting, setErrors } = actions;
    setSubmitting(true);

    try {
      // eslint-disable-next-line no-unused-vars
      const { property, buildingName, bedroomsCount, ...restValues } = values;
      const buildingNameToSend = get(buildingName, 'value', undefined);

      await API.moveoutProperty({
        ...dateRangeInfo,
        buildingName: buildingNameToSend,
        bedroomsCount: bedroomsCount.value,
        ...restValues
      });
      const { result: newUser } = await API.getUserProfile();
      updateUser(newUser);
      setSubmitting(false);
      onSubmit();
    } catch (err) {
      setSubmitting(false);
      const error = getErrors(err);
      if (error.message) {
        setErrors({
          googlePlaceID: error.message
        });
      } else {
        const validErrors = pick(error, [
          'buildingName',
          'bedroomsCount',
          'unitNumber',
          'googlePlaceID'
        ]);
        if (!isEmpty(validErrors)) {
          setErrors(validErrors);
        } else {
          setErrors({
            googlePlaceID: 'Would you please try again?'
          });
        }
      }
    }
  };

  render() {
    const { onCancel } = this.props;

    return (
      <Formik
        initialValues={{
          googlePlaceID: '',
          property: null,
          bedroomsCount: null,
          unitNumber: ''
        }}
        onSubmit={this.handleSubmit}
        validationSchema={validationSchema}
      >
        {({ isSubmitting, values }) => {
          const { googlePlaceID, property } = values;
          const hasMultipleBuildings =
            property &&
            property.buildingsNames &&
            property.buildingsNames.length > 0;

          const buildingNames =
            property && property.buildingsNames
              ? arry2KeyValue(property.buildingsNames)
              : [];
          const bedRooms = arry2KeyValue(
            property && property.bedroomsCounts
              ? property.bedroomsCounts
              : DEFAULT_BEDROOM_COUNTS,
            'Bedroom',
            {
              0: {
                value: 0,
                label: 'Studio'
              }
            }
          );

          return (
            <Form>
              <Box display="flex" flexDirection="column">
                <Text mb={4}>Where are you moving to?</Text>

                <Field
                  mb={4}
                  component={GooglePropertyField}
                  name="googlePlaceID"
                  label="Enter your address"
                />

                {hasMultipleBuildings && (
                  <Field
                    component={SelectField}
                    mb={4}
                    name="buildingName"
                    label="Building"
                    options={buildingNames}
                  />
                )}
                <Field
                  component={InputField}
                  mb={4}
                  disabled={!googlePlaceID}
                  name="unitNumber"
                  type="text"
                  label="Unit Number"
                />
                <Field
                  component={SelectField}
                  disabled={!googlePlaceID}
                  isSearchable={false}
                  mb={4}
                  name="bedroomsCount"
                  label="Number of Bedrooms"
                  options={bedRooms}
                  getValue="value"
                />

                <Box
                  display="flex"
                  flexDirection="row"
                  justifyContent="space-between"
                  alignItems="center"
                  mb={4}
                >
                  <Button
                    type="button"
                    onClick={onCancel}
                    variant="secondary"
                    mr={4}
                    flex={1}
                  >
                    Cancel
                  </Button>
                  <Button flex={1} type="submit" disabled={isSubmitting}>
                    Done
                  </Button>
                </Box>
              </Box>
            </Form>
          );
        }}
      </Formik>
    );
  }
}

const mapStatesToProps = state => ({
  dateRangeInfo: MoveoutSelectors.selectDateRangeInfo(state)
});

const mapDispatchToProps = dispatch => ({
  updateUser: newUserInfo => {
    dispatch(AuthActions.setUser(newUserInfo));
    dispatch(AppActions.setPriceDataLoadRequest());
  }
});

export default connect(
  mapStatesToProps,
  mapDispatchToProps
)(MoveoutPropertyForm);
